import { useQuery } from "@tanstack/react-query";
import { programmeDashboardApi } from "../api/programmeDashboard";
import { FilterItem } from "../../../shared/context/FilterContext";
import { extractFilterValues } from "../../../lib/filterUtils";

export interface VarianceAnalysisData {
  month: string;
  actual: number;
  variance: number;
}

const formatCurrency = (amount: number): number => {
  return amount / 1000000;
};

export const useVarianceAnalysis = ({ portfolio_id, quickFilters }: { portfolio_id: string | undefined, quickFilters: any }) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["variance-analysis", portfolio_id, quickFilters],
    queryFn: () => {
      const params = {
        portfolio_id: portfolio_id,
        workstream_id: extractFilterValues(quickFilters.workstream) || null,
        site_id: extractFilterValues(quickFilters.site) || null,
        programme_id: extractFilterValues(quickFilters.programme) || null,
        region_id: extractFilterValues(quickFilters.region) || null,
        work_type_group_id: extractFilterValues(quickFilters['worktype-group']) || null,
        project_year: extractFilterValues(quickFilters.projectYear) || null,
      };
      return programmeDashboardApi.fetchVarianceAnalysis(params)
    },
  });

  const chartData: VarianceAnalysisData[] = data?.data
    ? data.data.map((item) => ({
      month: item.month,
      actual: formatCurrency(item.totalActualSpend),
      variance: formatCurrency(item.variance),
    }))
    : [];

  return {
    chartData,
    isLoading,
    isError,
    error:
      error instanceof Error
        ? error.message
        : "Failed to fetch variance analysis",
  };
};

